import { SITE_URL, BRAND, PHONE_TEL, EMAIL, INSTAGRAM, OFFICE_LIST, imgSrc } from "@/data/site";

export function Seo({ title, description, path, image = "amber", type = "website", noindex = false, jsonLd = [] }) {
  const url = `${SITE_URL}${path === "/" ? "/" : path}`;
  const img = imgSrc(image, 1200);
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large"} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={BRAND} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="en_IN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {jsonLd.filter(Boolean).map((j, i) => (
        <script key={i} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(j) }} />
      ))}
    </>
  );
}

export const orgLd = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": `${SITE_URL}/#organization`,
  name: BRAND,
  url: SITE_URL,
  logo: `${SITE_URL}/logo512.png`,
  telephone: PHONE_TEL,
  email: EMAIL,
  founder: { "@type": "Person", name: "Lucky Choudhary" },
  sameAs: [INSTAGRAM],
  areaServed: { "@type": "State", name: "Rajasthan" },
});

export const websiteLd = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  name: BRAND,
  url: SITE_URL,
  publisher: { "@id": `${SITE_URL}/#organization` },
  inLanguage: "en-IN",
});

export const officeLd = (o) => ({
  "@context": "https://schema.org",
  "@type": ["LocalBusiness", "TaxiService"],
  "@id": `${SITE_URL}${o.path}#office`,
  name: `${BRAND} ${o.city}`,
  url: `${SITE_URL}${o.path}`,
  telephone: PHONE_TEL,
  email: EMAIL,
  image: imgSrc(o.key === "jaisalmer" ? "camel" : o.key, 1200),
  parentOrganization: { "@id": `${SITE_URL}/#organization` },
  address: {
    "@type": "PostalAddress",
    streetAddress: (o.address || "").split(`, ${o.city}`)[0],
    addressLocality: o.city,
    addressRegion: "Rajasthan",
    postalCode: o.postal,
    addressCountry: "IN",
  },
  areaServed: [{ "@type": "City", name: o.city }, { "@type": "State", name: "Rajasthan" }],
  openingHours: "Mo-Su 00:00-23:59",
});

export const allOfficesLd = () => OFFICE_LIST.map(officeLd);

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({ "@type": "ListItem", position: i + 1, name: it.label, item: `${SITE_URL}${it.path}` })),
});

export const faqLd = (faqs) =>
  Array.isArray(faqs) && faqs.length
    ? {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
      }
    : null;
